$(".hasChildITG").hover(function() {
    $(this).parents(".nav_main_menu_sec").addClass("showOverLay"), $(this).addClass("activeHover"), 
    $(this).find(".custom_submenu_sec").addClass("result_hover");
}, function() {
    $(this).parents(".nav_main_menu_sec").removeClass("showOverLay"), $(this).removeClass("activeHover"), 
    $(this).find(".custom_submenu_sec").removeClass("result_hover");
}), $(".rc-selling-plans").css("display", "block"), $(document).ready(function() {
    function t() {
        $(".bab_search").on("keyup", function() {
            var t = $(this).val().toLowerCase();
            $(".bab_products .grid__item.active.current").filter(function() {
                $(this).toggle($(this).text().toLowerCase().indexOf(t) > -1), i();
            });
        });
    }
    function e() {
        var t = $(".bab_p_price"), e = t.val(), a = t.find(":selected").attr("min-value"), i = t.find(":selected").attr("max-value");
        $(".bab_products .grid__item.active").each(function() {
            var t = $(this).attr("data-p_price");
            t > a && t < i ? $(this).addClass("current") : $(this).removeClass("current");
        }), "all_price" == e && $(".bab_products .grid__item").addClass("current");
    }
    function a() {
        var t = $(".bab_p_type").val();
        $(".bab_products .grid__item.current").each(function() {
            $(this).attr("data-p_type") != t ? $(this).removeClass("active") : $(this).addClass("active");
        }), "all_type" == t && $(".bab_products .grid__item").addClass("active");
    }
    function i() {
        0 == $("li.grid__item.active.current").length ? $(".noproducts").removeClass("hidden") : $(".noproducts").addClass("hidden");
    }
    function s() {
        var t = 0;
        $(".prod_item_container .prod___item").each(function() {
            var e = $(this).attr("data-price") * $(this).attr("data-qty");
            $.isNumeric(e) && (t += parseFloat(e));
        });
        var e = (t = t.toFixed(2)).toLocaleString();
        $(".bundle_total .prod__subtotal,.prod_total .prod__subtotal, .sticky_add_btn .total_price").html("$" + e);
    }
    $("#six_quiz_question .cutt-input-bar-sty input").click(function() {
        var t = $(this).attr("data-handle");
        $(".collection_go_button_sec").click(function(e) {
            window.location.href = t, e.preventDefault();
        });
    }), $("#six_quiz_question .cutt-input-bar-sty input").click(function() {
        var t = $(this).attr("value");
        $("#quiz_Result_page").find(".multiple_change_text").html(t);
    }), $(document).on("click", ".onetime-radio", function() {
        $(".recharge-subscription-widget div[data-v-app]").css("margin-bottom", "0px");
    }), $(document).on("click", ".subscription-radio", function() {
        $(".recharge-subscription-widget div[data-v-app]").css("margin-bottom", "55px");
    }), $(document).on("click", ".must_be_required_button ", function(t) {
        $(".check_button").is(":checked") ? $("#dialog").html("") : ($("#dialog").html("please check the box"), 
        t.preventDefault());
    }), $(".custom_add_to_cart_btn").click(function() {
        setTimeout(function() {
            $("#cart-icon-bubble").trigger("click");
        }, 1500);
    }), $("label.radio_label").on("click", function() {
        $(this).addClass("background_button_color").parent().siblings().children().removeClass("background_button_color");
    }), $('input[type="checkbox"]').change(function() {
        $(this).is(":checked") ? $(this).parent("label.multi_check_sec").addClass("checkbox_background_button_color") : $(this).parent("label.multi_check_sec").removeClass("checkbox_background_button_color");
    }), $("#first_quiz_question a.button.button--primary").click(function() {
        var t = $(".cust-mian-input-fil-sty input").val();
        $("#second_quiz_question").find(".input_value_get").html(t);
    }), $(".cstm_slider").slick({
        infinite: !0,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: !0,
        prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0623/7516/6196/files/Vector_1.png?v=1646636173"></div>',
        nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0623/7516/6196/files/Vector_2.png?v=1646636209"></div>',
        dots: !1,
        responsive: [ {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: !0,
                dots: !1
            }
        }, {
            breakpoint: 769,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        } ]
    }), $("select.bab_p_type option").each(function() {
        $(this).siblings('[value="' + this.value + '"]').remove();
    }), t(), i(), $(".bab_p_type").change(function() {
        a(), e(), t(), i();
    }), $(".bab_p_price").change(function() {
        e(), a(), t(), i();
    }), $(".bab_p_sort").change(function(t) {
        var e = $(this).val();
        "a-z" == e && ($(".bab_products ul").html($(".bab_products ul li").sort(function(t, e) {
            return $(t).text() < $(e).text() ? -1 : 1;
        })), $(".bab_products ul").get(0).selectedIndex = 0, t.preventDefault()), "z-a" == e && ($(".bab_products ul").html($(".bab_products ul li").sort(function(t, e) {
            return $(t).text() > $(e).text() ? -1 : 1;
        })), $(".bab_products ul").get(0).selectedIndex = 0, t.preventDefault()), "l-h" == e && ($(".bab_products ul").html($(".bab_products ul li").sort(function(t, e) {
            return $(t).attr("data-p_price") < $(e).attr("data-p_price") ? -1 : 1;
        })), $(".bab_products ul").get(0).selectedIndex = 0, t.preventDefault()), "h-l" == e && ($(".bab_products ul").html($(".bab_products ul li").sort(function(t, e) {
            return $(t).attr("data-p_price") > $(e).attr("data-p_price") ? -1 : 1;
        })), $(".bab_products ul").get(0).selectedIndex = 0, t.preventDefault());
    }), $(document).on("click", ".pro_select_btn", function() {
        var t = $(this).attr("data-clicked");
        $(this).attr("data-clicked", +t + 1);
        var e = $(this).attr("data-title"), a = $(this).attr("data-image"), i = $(this).attr("data-variantid"), n = $(this).attr("data-price"), o = $(this).attr("data-showprice"), c = $(this).attr("data-clicked");
        jQuery.fn.exists = function() {
            return this.length > 0;
        }, $('.prod_img_container li[data-id="' + i + '"], .bottom_sticky .sticky__item_container .sticky_item[data-id="' + i + '"], .prod_item_container .prod___item[data-id="' + i + '"], .bundle_item_container .bundle___item[data-id="' + i + '"]').exists() ? ($('.prod_img_container li[data-id="' + i + '"] span.p_qty').text(c), 
        $('.bottom_sticky .sticky__item_container .sticky_item[data-id="' + i + '"] span.p_qty').text(c), 
        $('.prod_item_container .prod___item[data-id="' + i + '"] span.prod___qty').text(c), 
        $('.prod_item_container .prod___item[data-id="' + i + '"]').attr("data-qty", c), 
        $('.bundle_item_container .bundle___item[data-id="' + i + '"] span.prod___qty').text(c), 
        $('.bundle_item_container .bundle___item[data-id="' + i + '"]').attr("data-qty", c), 
        $('.cart__data .box_cart_item[data-vid="' + i + '"]').attr("data-qty", c)) : ($(".prod_img_container").append('<li data-id="' + i + '"><img src="' + a + '"><span class="p_qty">' + c + "</span></li>"), 
        $(".bottom_sticky .sticky__item_container").append('<div class="sticky_item" data-id="' + i + '"><img src="' + a + '"><span class="p_qty">' + c + '</span><span class="remove_icon" data-vid="' + i + '">&#x2715;</span></div>'), 
        $(".prod_item_container").append('<div class="prod___item" data-id="' + i + '" data-price="' + n + '" data-qty="' + c + '"><span class="prod___qty">' + c + '</span><span class="prod___title">' + e + '</span><span class="prod___price">' + o + '</span><span class="prod___remove" data-vid="' + i + '">&#x2715;</span>'), 
        $(".bundle_item_container").append('<div class="bundle___item" data-id="' + i + '" data-price="' + n + '" data-qty="' + c + '"><span class="prod___qty">' + c + '</span><span class="prod___img"><img src="' + a + '"></span><span class="prod___title">' + e + '</span><span class="prod___price">' + o + '</span><span class="prod___remove" data-vid="' + i + '">&#x2715;</span>'), 
        $(".cart__data").append('<div class="box_cart_item" data-vid="' + i + '" data-qty="' + c + '"></div>')), 
        s(), $(".added_items_section, .bottom_sticky").removeClass("hidden");
    }), $(document).on("click", ".prod_item_container .prod___remove, .sticky_item span.remove_icon,.bundle_item_container .prod___remove", function() {
        var t = $(this).attr("data-vid");
        $('.prod_img_container li[data-id="' + t + '"], .bottom_sticky .sticky__item_container .sticky_item[data-id="' + t + '"], .prod_item_container .prod___item[data-id="' + t + '"], .bundle_item_container .bundle___item[data-id="' + t + '"], .cart__data .box_cart_item[data-vid="' + t + '"]').remove(), 
        $(".pro_select_btn").attr("data-clicked", 0), s(), 0 == $(".prod_img_container li").length && $(".added_items_section, .bottom_sticky").addClass("hidden");
    }), $(document).on("click", ".box_add_btn,.card_selection", function() {
        $(".added_items_section, .bottom_sticky").removeClass("hidden"), $(".page_subtitle").hide(), 
        $('.step_data[data-step="step-1"], .step__bar .title_inner[data-step="step-1"]').removeClass("active"), 
        $("#giftbox-progress-bar .step_1").addClass("completed"), $('#giftbox-progress-bar .step_2, .step__bar .title_inner[data-step="step-2"],.step_data[data-step="step-2"]').addClass("active");
    }), $(document).on("click", ".edit_box", function() {
        $(".step.step_1").trigger("click");
    }), $(document).on("click", ".step.step_1", function() {
        $(".page_subtitle").show();
    }), $(document).on("click", ".step.step_2,.step.step_3", function() {
        $(".page_subtitle").hide();
    }), $(document).on("click", "#giftbox-progress-bar .step.completed", function() {
        var t = $(this).attr("data-step");
        $("[data-step]").removeClass("active"), $('[data-step="' + t + '"]').addClass("active"), 
        $(".sticky_add_btn").removeClass("card_selection").addClass("build_box_btn"), $(".added_items_section, .bottom_sticky").removeClass("hidden");
    }), $(document).on("click", ".card_variant", function() {
        $(".added_items_section, .bottom_sticky").removeClass("hidden"), $(".card_variant").not(this).prop("checked", !1);
        var t = $(".card__item input.card_variant[type=checkbox]:checked").val();
        $(".cart__data .selected_card").attr({
            "data-vid": t,
            "data-qty": "1"
        });
    }), $(document).on("click", ".final_add_btn", function() {
        $(".added_items_section, .bottom_sticky").addClass("hidden");
        var t = $(".card__item input.card_variant[type=checkbox]:checked").val(), e = $(".card__item input[type=checkbox]:checked+label img").attr("src"), a = $(".card__item input[type=checkbox]:checked").attr("data_ptitle"), i = "Type: " + $(".card__item input[type=checkbox]:checked").attr("data_vtitle"), s = $(".card__item input[type=checkbox]:checked").attr("data_price"), n = $(".card__item input[type=checkbox]:checked").attr("data_showprice");
        if ($(".card_variant").is(":checked")) {
            if (0 === $(".message_to").val().length) var o = ""; else o = "To: " + $(".message_to").val();
            if (0 === $(".message_from").val().length) var c = ""; else c = "From: " + $(".message_from").val();
            if (0 === $(".message_box").val().length) {
                alert("Are you sure you don't want to write a message?");
                var d = "";
            } else d = "Message: " + $(".message_box").val();
            $(".bundle_item_container .bundle_card_item").exists() ? ($(".bundle_item_container .bundle_card_item").attr("data-id", t), 
            $(".bundle_item_container .bundle_card_item img").attr("src", e), $(".bundle_item_container .bundle_card_item .prod___title .title_info").html(a + "<br>" + i), 
            $(".bundle_item_container .bundle_card_item .message_info").html(o + "<br>" + c + "<br>" + d)) : $(".bundle_item_container").append('<div class="bundle___item bundle_card_item" data-id="' + t + '" data-price="' + s + '" data-qty="1"><span class="prod___qty">1</span><span class="prod___img"><img src="' + e + '"></span><span class="prod___title"><span class="title_info">' + a + "<br>" + i + '</span><span class="message_info">' + o + "<br>" + c + "<br>" + d + '</span></span><span class="prod___price">' + n + '</span><span class="prod___remove" data-vid="' + t + '">&#x2715;</span>');
        }
        $('.step_data[data-step="step-2"],.step__bar .title_inner[data-step="step-2"]').removeClass("active"), 
        $("#giftbox-progress-bar .step_2").addClass("completed"), $('#giftbox-progress-bar .step_3, .step__bar .title_inner[data-step="step-3"],.step_data[data-step="step-3"]').addClass("active");
    }), $(document).on("click", ".reset_bundle", function(t) {
        1 == confirm("Do you want to create new bundle. if you confirm yes then your existing bundle will be lost") && (url = $(this).attr("data-url"), 
        window.location.href = url);
    }), $(document).on("click", ".complete_box,.build_box_btn", function(t) {
        if (1 == confirm("Do you want to build final bundle.")) {
            var e = $(".message_to").val(), a = $(".message_from").val(), i = $(".message_box").val(), s = Math.floor(7e7 * Math.random() + 1);
            t.preventDefault(), Shopify.queue = [], $(".box_cart_item").each(function() {
                var t = $(this).attr("data-vid"), e = $(this).attr("data-qty");
                Shopify.queue.push({
                    variantId: t,
                    quantity: e
                });
            }), Shopify.moveAlong = function() {
                if (Shopify.queue.length) {
                    var t = Shopify.queue.shift(), n = "id=" + t.variantId + "&quantity=" + t.quantity + "&properties%5BBox%20unique%20id%5D=" + s + "&properties%5BTo%5D=" + e + "&properties%5BFrom%5D=" + a + "&properties%5BMessage%5D=" + i;
                    console.log(n), $.ajax({
                        url: "/cart/add.js",
                        dataType: "json",
                        type: "post",
                        data: n,
                        success: function(t) {
                            Shopify.moveAlong();
                        },
                        error: function() {
                            Shopify.queue.length && Shopify.moveAlong();
                        }
                    });
                } else $(".complete_box").css("pointer-events", "none"), setTimeout(function() {
                    window.location.href = "/cart";
                }, 5e3);
            }, Shopify.moveAlong();
        }
    });
});
